var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpwardArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8921 11.5891C11.2891 11.5847 11.6096 11.2633 11.6129 10.8663L11.6947 1.01033C11.6993 0.451014 11.2459 -0.00338629 10.6866 0.00153812C7.86389 0.0263903 3.52296 0.0573554 0.81886 0.0817298C0.425731 0.0852735 0.108969 0.401624 0.10251 0.794717C0.0958076 1.20264 0.426698 1.53581 0.834664 1.53212C2.61943 1.51599 4.71311 1.50127 6.77097 1.48504C7.66624 1.47798 8.12019 2.56073 7.48712 3.1938L0.210413 10.4704C-0.0697539 10.7506 -0.0697567 11.2048 0.210408 11.485C0.490573 11.7652 0.944813 11.7652 1.22498 11.485L8.50176 4.20826C9.13482 3.5752 10.2169 4.02918 10.2088 4.92443L10.1552 10.8536C10.1515 11.2619 10.4838 11.5936 10.8921 11.5891Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardArrow);
export default __webpack_public_path__ + "static/media/upwardArrow.f1f82572ca9d310b85de72aaaf074087.svg";
export { ForwardRef as ReactComponent };